import React from 'react';

const ProjectCard = ({ title, link, description }) => {
    return (
        <li>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href={link}
                style={{ borderBottomWidth: 0.5 }}
                className="border-dotted hover:border-transparent transition ease-in-out duration-300"
            >
                {title}
            </a>
            <p className="text-base tracking-normal mt-3 lg:mt-6">
                {description.split('\n').map((i, key) => (
                    <div key={key}>{i}</div>
                ))}
            </p>
        </li>
    );
};

export default ProjectCard;
